import { ETableColumnType } from '@/interfaces'

export const PROCESSING_DEPOSITS_COLUMNS = [
  {
    minWidth: '100px',
    width: 15,
    key: 'mpiAssignee',
    searchKey: 'mpiAssignee',
    label: 'Assigned',
    hasSort: true,
    hasSearch: true,
    type: ETableColumnType.default
  },
  {
    minWidth: '140px',
    width: 10,
    key: 'willowId',
    searchKey: 'id',
    label: 'Deposit Id',
    hasSort: true,
    hasSearch: true,
    type: ETableColumnType.default
  },
  {
    minWidth: '120px',
    width: 15,
    key: 'chain',
    searchKey: 'chainName',
    label: 'Chain Name',
    hasSort: true,
    hasSearch: true,
    type: ETableColumnType.default
  },
  {
    minWidth: '120px',
    width: 15,
    key: 'profilesMerchantAccount',
    searchKey: 'profilesMerchantAccount',
    label: 'Facility Name',
    hasSort: true,
    hasSearch: true,
    type: ETableColumnType.default
  },
  {
    minWidth: '130px',
    width: 10,
    key: 'paymentMethodType',
    searchKey: 'paymentMethodType',
    label: 'Payment Type',
    hasSort: true,
    hasSearch: true,
    type: ETableColumnType.default
  },
  {
    headClass: 'bt-justify-content-end',
    class: 'text-right',
    minWidth: '100px',
    width: 12,
    key: 'amount',
    searchKey: 'amount',
    label: 'Amount',
    hasSort: true,
    hasSearch: true,
    type: ETableColumnType.numberRange
  },
  {
    minWidth: '100px',
    width: 12,
    key: 'bankAccount',
    searchKey: 'bankAccount',
    label: 'Bank Account',
    hasSort: true,
    hasSearch: true,
    type: ETableColumnType.default
  },
  {
    minWidth: '110px',
    width: 12,
    key: 'depositDate',
    searchKey: 'depositDate',
    label: 'Deposit Date',
    hasSort: true,
    hasSearch: true,
    type: ETableColumnType.dateRange
  },
  {
    minWidth: '150px',
    width: 25,
    key: 'login',
    searchKey: 'login',
    label: 'Log in  & Password',
    hasSort: true,
    hasSearch: true,
    type: ETableColumnType.default
  },
  {
    minWidth: '16px',
    width: 5,
    key: 'downloadExportFile',
    type: ETableColumnType.secondaryActions
  },
  {
    minWidth: '16px',
    width: 5,
    key: 'failedValidation',
    type: ETableColumnType.secondaryActions
  },
  {
    minWidth: '120px',
    width: 20,
    key: 'markDepositAsSync',
    type: ETableColumnType.secondaryActions
  }
]

export const POSTED_DEPOSITS_COLUMNS = [
  {
    minWidth: '100px',
    width: 15,
    key: 'mpiAssignee',
    searchKey: 'mpiAssignee',
    label: 'Assigned',
    hasSort: true,
    hasSearch: true,
    type: ETableColumnType.default
  },
  {
    minWidth: '140px',
    width: 10,
    key: 'willowId',
    searchKey: 'id',
    label: 'Deposit Id',
    hasSort: true,
    hasSearch: true,
    type: ETableColumnType.default
  },
  {
    minWidth: '120px',
    width: 15,
    key: 'chain',
    searchKey: 'chainName',
    label: 'Chain Name',
    hasSort: true,
    hasSearch: true,
    type: ETableColumnType.default
  },
  {
    minWidth: '120px',
    width: 15,
    key: 'profilesMerchantAccount',
    searchKey: 'profilesMerchantAccount',
    label: 'Facility Name',
    hasSort: true,
    hasSearch: true,
    type: ETableColumnType.default
  },
  {
    minWidth: '130px',
    width: 10,
    key: 'paymentMethodType',
    searchKey: 'paymentMethodType',
    label: 'Payment Type',
    hasSort: true,
    hasSearch: true,
    type: ETableColumnType.default
  },
  {
    headClass: 'bt-justify-content-end',
    class: 'text-right',
    minWidth: '100px',
    width: 12,
    key: 'amount',
    searchKey: 'amount',
    label: 'Amount',
    hasSort: true,
    hasSearch: true,
    type: ETableColumnType.numberRange
  },
  {
    minWidth: '100px',
    width: 12,
    key: 'bankAccount',
    searchKey: 'bankAccount',
    label: 'Bank Account',
    hasSort: true,
    hasSearch: true,
    type: ETableColumnType.default
  },
  {
    minWidth: '110px',
    width: 12,
    key: 'depositDate',
    searchKey: 'depositDate',
    label: 'Deposit Date',
    hasSort: true,
    hasSearch: true,
    type: ETableColumnType.dateRange
  },
  {
    minWidth: '150px',
    width: 25,
    key: 'login',
    searchKey: 'login',
    label: 'Log in  & Password',
    hasSort: true,
    hasSearch: true,
    type: ETableColumnType.default
  },
  {
    minWidth: '16px',
    width: 5,
    key: 'downloadExportFile',
    type: ETableColumnType.secondaryActions
  },
  {
    minWidth: '16px',
    width: 5,
    key: 'downloadReportFile',
    type: ETableColumnType.secondaryActions
  }
]
